/* eslint-disable no-undef */

function initApiHost() {
  const scheme = isProduction ? 'https' : 'http';
  const name = isProduction ? productionApiDomain : window.location.hostname;
  const port = isProduction ? '443' : '8080';

  // const baseUrl = isProduction
  //   ? `${scheme}://${name}`
  //   : `${scheme}://${name}:${port}`;

  const baseUrl = isProduction ? `//${name}` : `//${name}:${port}`;

  // const baseUrl = isProduction ? `//${name}` : `//${name}:${port}`;

  return {
    name,
    port,
    scheme,
    baseUrl,
  };
}

const productionBaseDomain = 'menur.app';
const productionFullDomain = `azure.${productionBaseDomain}`;
const productionApiDomain = `api.${productionFullDomain}`;
const isProduction = window.location.hostname.includes(productionBaseDomain);
// const isProduction = true;
const apiHost = initApiHost();

const isDevEnv = !isProduction;

export { apiHost, isDevEnv };
